import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, makeObservable, observable, runInAction } from "mobx";
import { truncateMiddle } from "@devowl-wp/react-utils";
class ScannerResultExternalUrlSingle {
    busy = false;
    data;
    get markup() {
        return this.store.resultMarkup.get(this.data.id);
    }
    get blockedUrlTruncate() {
        return truncateMiddle(this.data.blockedUrl, 50, "[...]");
    }
    get sourceUrlTruncate() {
        return truncateMiddle(this.data.sourceUrl, 50, "[...]");
    }
    store;
    constructor(template, store){
        makeObservable(this);
        runInAction(()=>{
            this.data = template;
        });
        this.store = store;
    }
    fetchMarkup = flow(function*() {
        yield this.store.fetchMarkup(this.data.id);
    });
}
_ts_decorate([
    observable
], ScannerResultExternalUrlSingle.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ScannerResultExternalUrlSingle.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrlSingle.prototype, "markup", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrlSingle.prototype, "blockedUrlTruncate", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ScannerResultExternalUrlSingle.prototype, "sourceUrlTruncate", null);
export { ScannerResultExternalUrlSingle };
